import { i18n } from "core/i18n";
import { recordLinkV2 } from "utilities/tagging"
import { AUTHORISE_REQUEST, AUTHORISE_STEPS } from "../constants/bringAccountConstants";
import { CANCEL_FLOW_MODAL, STEP_DESCRIPTION, STEP_EVENT_NAME, TEALIUM, TEALIUM_EVENTS, WIZARD_BUTTON_FINISH } from "../constants/bringAccountConstantsTagging"

const { formatText } = i18n;

// PRELEAVE MODAL
export const taggingPreLeaveModal = (caseKey) => {
    const taggingEventData = CANCEL_FLOW_MODAL[caseKey];
    if (taggingEventData) {
        return taggingEventData()
    }
}

// WIZARD ACTIONS
export const taggingWizardAction = (caseKey) => {
    const taggingEventData = TEALIUM_EVENTS[caseKey];
    if (taggingEventData) {
        return taggingEventData()
    }
}

// WIZARD STEPS
export const getTaggingWizard = (immAccount, immBringAccount) => {
    const currentStep = immBringAccount.get('currentStep');
    const processDetail = STEP_DESCRIPTION[currentStep]

    return {
        ...TEALIUM,
        categoriaEvento: STEP_EVENT_NAME[currentStep],
        pageName: `/transferAccount/step${currentStep}/${processDetail}`,
        processStep: `step${currentStep}`,
        processDetail: STEP_DESCRIPTION[currentStep],
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
    }
}

// WIZARD SUCCESS STEP
export const getTaggingSuccessStep = (immAccount) => {
    return {
        ...TEALIUM,
        eventName: "step_success",
        nombrePagina: '/transferAccount/success',
        processStep: 'success',
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
    }
}

// WIZARD ERROR STEP
export const getTaggingErrorStep = (immAccount) => {
    return {
        ...TEALIUM,
        eventName: "step_error",
        nombrePagina: "/transferAccount/error/notPossibleToCompleteTheRequest",
        processStep: 'error',
        processDetail: "notPossibleToCompleteTheRequest",
        productName: `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`,
        categoryError: "notPossibleToCompleteTheRequest",
        descriptionError: formatText("transfer_account-transfer_account_from_another_bank_error_screen_subtitle")
    }
}

// STEP ONE
export const taggingTooltip = () => {
    recordLinkV2({
        action: "open",
        format: "tooltip",
        component: "transferDate",
        element: "selectDate",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "openTooltip",
        eventLabel: "selectDate"
    })
}

export const taggingIban = () => {
    recordLinkV2({
        action: "type",
        format: "textBox",
        component: "originAccount",
        element: "accountNumber",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "clickTextBox",
        eventLabel: "accountNumber"
    })
}

export const taggingIbanError = ({ isValidIban, existsIban, ibanMessageError }) => {
    let element = ""
    if (!isValidIban) {
        element = "incorrectIBAN";
    }
    if (!existsIban) {
        element = "inexistentIBAN";
    }

    recordLinkV2({
        action: "type",
        format: "textBox",
        component: "originAccount",
        element,
        errorCategory: element,
        errorDescription: ibanMessageError,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "typeTextbox",
        eventLabel: "error - textbox"
    })
}

export const taggingDatePicker = (isOpen = false) => {
    recordLinkV2({
        action: isOpen ? 'open' : 'close',
        format: "dropdown",
        component: "calendar",
        element: "selectDate",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "calendarDropdown",
        eventLabel: isOpen ? 'open' : 'close',
    })
}

export const taggingDatePickerError = (dateError) => {
    recordLinkV2({
        action: "select",
        format: "dropdown",
        component: "calendar",
        element: "invalidDate",
        errorCategory: "invalidDate",
        errorDescription: dateError,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "typeTextbox",
        eventLabel: "error - textbox"
    })
}

// STEP THREE
export const taggingOpenTooltip = (component) => {
    recordLinkV2({
        action: "click",
        format: "link",
        component,
        element: "needHelp",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "clickLink",
        eventLabel: "needHelp"
    })
}


export const taggingOpenedTooltip = (component) => {
    recordLinkV2({
        action: "open",
        format: "modal",
        component: "modal/needHelp",
        element: "full",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "needHelp",
        eventLabel: "full"
    })
}

export const taggingCloseTooltip = (isClose) => {
    const typeAction = isClose ? "close" : "cancel";
    recordLinkV2({
        action: typeAction,
        format: "cross",
        component: "modal/needHelp",
        element: typeAction,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "needHelp",
        eventLabel: typeAction
    })
}

export const taggingUnderstoodTooltip = () => {
    recordLinkV2({
        action: "click",
        format: "button",
        component: "modal/needHelp",
        element: "understood",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "needHelp",
        eventLabel: "understood"
    })
}

export const taggingAuthoriseCheckbox = (type, checkboxItem) => {
    const action = checkboxItem.isChecked ? "check" : "uncheck";
    const eventLabel = checkboxItem.isChecked ? "checked" : "unchecked";
    const component = type === AUTHORISE_REQUEST ? "requestProducts" : "stepsAuthorization";
    const eventAction = type === AUTHORISE_STEPS ? "requestProductsCheckBox" : "stepsAuthorizationCheckBox";

    recordLinkV2({
        action,
        format: "checkBox",
        component,
        element: checkboxItem.index + 1,
        eventCategory: window.utag_data.nombrePagina,
        eventAction,
        eventLabel,
    })
}

// STEP FOUR
export const taggingFinishProcess = () => {
    recordLinkV2(TEALIUM_EVENTS[WIZARD_BUTTON_FINISH]())
}

// ERROR STEP
export const taggingErrorStepRedirect = (pathname) => {
    recordLinkV2({
        action: "click",
        format: "link",
        component: "lowerNavigation",
        element: "goToTheAccount",
        pathname,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "lowerNavigation",
        eventLabel: "goToTheAccount",
    })
}


// SUCCESS STEP
export const taggingSuccessStepRedirect = (pathname) => {
    recordLinkV2({
        action: "click",
        format: "link",
        component: "lowerNavigation",
        element: "goToAccounts",
        pathname,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "lowerNavigation",
        eventLabel: "goToAccounts"
    })
}

export const taggingDownloadDocument = () => {
    recordLinkV2({
        action: "download",
        format: "button",
        component: "lowerNavigation",
        element: "downloadForm",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "lowerNavigation",
        eventLabel: "downloadForm"
    })
}

export const taggingDownloadDocumentSuccess = () => {
    recordLinkV2({
        action: "open",
        format: "snackbar",
        component: "snackbar/success/requestDownloaded",
        element: "full",
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "snackbar/success/requestDownloaded",
        eventLabel: "open"
    })
}

export const taggingDownloadDocumentError = (errorDescription) => {
    recordLinkV2({
        action: "open",
        format: "snackbar",
        component: "snackbar/error/cantDownloadRequest",
        element: "full",
        errorCategory: "cantDownloadRequest",
        errorDescription,
        eventCategory: window.utag_data.nombrePagina,
        eventAction: "snackbar/error/cantDownloadRequest",
        eventLabel: "open"
    })
}
